<template>
    <div :class="['container', _isMobile() ? 'mobile' : '']">
        <router-view />
    </div>
  </template>
  
  <script>
  import { mixinDevice } from "@/utils/mixin.js";
  export default {
    name: "FullScreenLayout",
    mixins: [mixinDevice],
    components: {
    },
    data() {
      return {
      };
    },
    created() {
  
    },
  };
  </script>
  <style>
    a *{
      transition: all 0.1s ease;
    }
  </style>
  <style lang="less" scoped>
  .container {
    .banner-wrap {
     padding: 80px 0;
      background: #24A6E9;
      .banner-bg{
        position: absolute;
        width: 100%;
      }
      .banner {
        margin: auto;
        max-width: 1200px;
        overflow: hidden;
        border-radius: 28px;
        box-shadow: 0px 6px 10px #0303031f;
      }
    }
    /deep/.ant-list-pagination {
      text-align: center;
    }
    // background: url(~@/assets/background.svg);
  }
  </style>